import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ViolationDetailsDto, ViolationItemDetailsDto } from '../../../../../../api/gen';
import { JJamesBadgeComponent, BadgeVariant } from 'shared-lib';

@Component({
  selector: 'app-parking-zone-parking-violation-details',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    JJamesBadgeComponent
  ],
  templateUrl: './parking-zone-parking-violation-details.component.html',
  styleUrl: './parking-zone-parking-violation-details.component.scss'
})
export class ParkingZoneParkingViolationDetailsComponent {
  @Input({ required: true }) violationDetails!: ViolationDetailsDto;
  @Input() expanded: boolean = false;

  @Output() close = new EventEmitter<void>();

  getStatusBadgeVariant(): BadgeVariant {
    return this.violationDetails.hasActiveViolations ? 'danger' : 'warning';
  }

  getStatusText(): string {
    return this.violationDetails.hasActiveViolations ? 'Active Violations' : 'Resolved';
  }

  getViolationTypeBadgeVariant(item: ViolationItemDetailsDto): BadgeVariant {
    return item.isActive ? 'danger' : 'secondary';
  }

  formatDate(dateStr: string | null | undefined): string {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleString();
  }

  formatDuration(duration: string | null | undefined): string {
    if (!duration) return 'N/A';
    const parts = duration.split(':');
    if (parts.length >= 2) {
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    }
    return duration;
  }

  onClose(): void {
    this.close.emit();
  }
}
